module.exports = __webpack_public_path__ + "static/media/p-light_1.70e91c17.jpg";